import React, { useState, useMemo, useEffect } from "react";
import Box from "Components/Atoms/Box";
import "./styles.scss";
import useLocalStorageState from "CustomHooks/useLocalStorageState";
import useDocument from "CustomHooks/useDocument";
import useCollection from "CustomHooks/useCollection";
import { Notes as NotesIcon } from "@material-ui/icons";
import Modal from "Components/Molecules/Modal";
import TextField from "Components/Atoms/TextField";
import firebase from "utils/firebase";
import AlertsTab from "./AlertsTab";

export type AdminNotesProps = {
  restaurantId: string;
};

const AdminNotes: React.FC<AdminNotesProps> = ({ restaurantId }) => {
  const [open, setopen] = useLocalStorageState("adminNotes", false);

  const [tab, settab] = useState<"notes" | "alerts">("notes");

  const [noteDoc, setnoteDoc] = useDocument<{
    notes: string;
    editedAt: number;
  }>(`/adminNotes`, restaurantId);

  if (!open) {
    return (
      <Box
        onClick={() => setopen(true)}
        style={{
          position: "fixed",
          width: "auto",
          bottom: 20,
          right: 20,
          zIndex: 1000,
          borderRadius: 20,
          height: 40,
          padding: 8,
          backgroundColor: noteDoc.data?.notes?.length
            ? "var(--color-primary)"
            : "var(--color-border)",
        }}
      >
        <NotesIcon style={{ height: 24, width: 24 }} />
      </Box>
    );
  }

  return (
    <>
      <Modal
        title="Notizen & Alerts"
        open={open}
        onClose={() => setopen(false)}
        maxWidth="sm"
        fullWidth
        tabs={[
          { id: "notes", label: "Notizen" },
          { id: "alerts", label: "Alerts" },
        ]}
        value={tab}
        onChange={(v) => settab(v as "notes" | "alerts")}
      >
        {(val: string | number | null) =>
          val === "notes" ? (
            <TextField
              value={noteDoc.data?.notes || ""}
              onChange={(e) =>
                setnoteDoc({ notes: e.target.value, editedAt: Date.now() })
              }
              onBlur={() => {
                noteDoc.ref.set({
                  notes: noteDoc?.data?.notes ?? "",
                  editedAt: Date.now(),
                });
              }}
              multiline
              minRows={6}
              fullWidth
            />
          ) : (
            <AlertsTab restaurantId={restaurantId} />
          )
        }
      </Modal>
    </>
  );
};

export default AdminNotes;
